module.exports = __webpack_public_path__ + "static/media/photo154.6521797d.jpg";